<template>
  <div class="general-form-wrap payment-info-wrap box-wrapper">
    <BaseLoading  :spinning="payingLoading || paymentLoading">
      <div class="payment-form-wrap">
        <div class="heading">
          <h2 class="form-title">Add Payment</h2>
        </div>
        <a-form layout="horizontal" :form="form">
          <div class="add-payment-container">
            <a-row :gutter="32">
              <a-col :sm="24">
                <a-form-item
                  v-bind="formItemLayout"
                  label="Choose Your Plan"
                  :validate-status="handleError('plan') ? 'error' : ''"
                  :help="handleError('plan') || ''"
                >
                  <a-select
                    show-search
                    option-filter-prop="children"
                    :filter-option="filterOption"
                    @change="handlePlanChange"
                    v-decorator="[
                      'plan',
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Please select one!'
                          }
                        ]
                      }
                    ]"
                    placeholder="Select Plan"
                  >
                    <a-select-option
                      v-for="plan in planList"
                      :key="plan._id"
                      :value="plan._id"
                    >
                      {{
                        plan._id === "601d2cf5500526206c4d60ee"
                          ? "Free"
                          : `$${plan.price}`
                      }}
                      {{
                        plan._id === "601d2cf5500526206c4d60ee"
                          ? `| ${plan.duration} days`
                          : `| ${Number(plan.duration) / 30} months`
                      }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :sm="24" v-if="!isFree">
                <div class="promo-container">
                  <div class="head">If you have promo code apply here</div>
                  <div class="promo-wrap">
                    <BaseFormInput
                      placeholder="Promo code"
                      :value="paymentPromoCode"
                      @change="e => (paymentPromoCode = e.target.value)"
                    />
                    <div class="promo-send">
                      <a-tooltip>
                        <template slot="title"
                          >Apply promo code to get discount.</template
                        >
                        <a-button
                          type="primary"
                          @click="handlePromoCodeSubmission"
                          :disabled="!paymentPromoCode || this.promoCode.id"
                          >Apply</a-button
                        >
                      </a-tooltip>
                    </div>
                  </div>
                </div>
                <!-- <div class="promo-info" v-if="this.promoInfo.status">
                {{ this.promoInfo.data }}
              </div>-->
              </a-col>
              <a-col :sm="24" class="amount-display-wrapper">
                <p v-if="discountedAmount">
                  discounted amount: ${{ discountedAmount }}
                </p>
                <p v-if="paymentAmount">total: ${{ paymentAmount }}</p>
              </a-col>
              <a-col v-if="isFree" style="pointer-events:none;">
                <p class="dark-hint-wrapper">
                  <span class="font-weight-bold">
                   During our FREE Trial enjoy all PREMIUM features for a limited time. For more information on our features please see our Pricing page. </span
                  >
                  <span class="black-bold"> pricing </span>
                  <span class="font-weight-bold">page</span>
                </p>
              </a-col>
              <a-col :sm="24">
                <a-form-item
                  :validate-status="handleError('agreement') ? 'error' : ''"
                  :help="handleError('agreement') || ''"
                >
                  <a-checkbox v-model="agreementCheck">
                    <span class="black-bold">
                      I have read and agreed to the website terms and
                      conditions
                    </span>
                  </a-checkbox>
                </a-form-item>
              </a-col>
              <a-col :sm="24" v-if="!isFree">
                <PaypalPayment
                  :payable="false"
                  @handle-unpayable="handlePaypalException"
                  v-if="!agreementCheck || !selectedPaymentPlanId"
                  unique-slug="AthleteProfile"
                  :profile-id="athleteId"
                />
                <PaypalPayment
                  :amount="paymentAmount"
                  @paying="payment => (payingLoading = payment)"
                  @transaction-completed="handleTransactionApproval"
                  :description="`Profile Create for ${athlete.athleteName}`"
                  unique-slug="AthleteProfile"
                  :profile-id="athleteId"
                  :promocode="paymentPromoCode"
                  :discountAmount="discountedAmount"
                  v-else
                />
              </a-col>
              <a-col :sm="24" v-if="isFree">
                <a-button
                  class="next-button first-save-button"
                  type="primary"
                  @click="handleSubmit"
                  >submit</a-button
                >
              </a-col>
            </a-row>
          </div>
        </a-form>
      </div>
    </BaseLoading>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import PaypalImage from "@/assets/images/paypal.png";
import PaypalPayment from "@/views/paypal/index";

import router from "../../../../router";

import { RepositoryFactory } from "../../../../repositories/RepositoryFactory";
const STORE_KEY = "playerStore";
const ATHLETE_STORE_KEY = "athleteStore";
const PAYMENT_STORE_KEY = "paymentStore";

const GetPlanRepository = RepositoryFactory.get("users");
const AthleteRepository = RepositoryFactory.get("athlete");

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

export default {
  name: "AddPayment",
  components: {
    PaypalPayment
  },
  data() {
    return {
      Paypal: PaypalImage,
      planList: [],
      paymentAmount: "",
      paymentDuration: "",
      selectedPaymentPlanId: "",
      paymentPromoCode: "",
      discountedAmount: "",
      payingLoading: false,
      value: 1,
      isFree: false,
      agreementCheck: false,
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        }
      },
      hasErrors,
      form: this.$form.createForm(this)
    };
  },
  mounted() {
    this.$nextTick(() => {
      // To disabled submit button at the beginning.
      this.form.validateFields();
    });
  },
  created() {
    this.dispatcher();
  },
  computed: {
    ...mapGetters({
      getEditProfileData: `${STORE_KEY}/getEditProfileData`,
      paymentPlans: `${PAYMENT_STORE_KEY}/paymentPlans`,
      promoCode: `${PAYMENT_STORE_KEY}/promoCode`,
      payment: `${PAYMENT_STORE_KEY}/payment`,
      paymentLoading: `${PAYMENT_STORE_KEY}/paymentLoading`,
      promoCodeValidation: `${PAYMENT_STORE_KEY}/promoCodeValidation`,
      athlete: `${ATHLETE_STORE_KEY}/athlete`,
      initializePayment: `${PAYMENT_STORE_KEY}/initializePayment`
    }),
    athleteId() {
      return this.id || this.$route.params.id;
    },
    disableCheck() {
      return this.agreementCheck;
    }
  },
  methods: {
    handlePaypalException() {
      this.$notification.error({
        message: "Error",
        description: "Please Agree To Terms To Proceed And Select a Term Plan."
      });
    },
    handleTransactionApproval(details) {
      this.promoCode.id
        ? this.submitWithPromoCode(details)
        : this.submitWithoutPromoCode(details);
    },
    async handlePromoCodeSubmission() {
      await this.$store.dispatch(`${PAYMENT_STORE_KEY}/checkPromoCode`, {
        code: this.paymentPromoCode,
        pricingPlan: this.selectedPaymentPlanId,
        id: this.$route.params.id,
        discountFor: "AthleteProfile"
      });
      await this.$store.dispatch(`${PAYMENT_STORE_KEY}/promoCodeValidation`, {
        code: this.paymentPromoCode,
        planId: this.selectedPaymentPlanId,
        withPromo: "promo",
        amount: this.paymentAmount
      });
    },
    async submitWithoutPromoCode(details) {
      await this.$store.dispatch(`${PAYMENT_STORE_KEY}/paypalPaymentNormal`, {
        type: "athlete",
        duration: Number(this.paymentDuration),
        lastPlanId: this.selectedPaymentPlanId,
        profileId: this.$route.params.id,
        orderId: details.id,
        initPaymentId: this.initializePayment.paymentId,
        uSlug: "AthleteProfile",
      });
      await this.$store.dispatch(`${PAYMENT_STORE_KEY}/createPaymentHistory`, {
        paymentDate: new Date(Date.now()),
        termPlan: Number(this.paymentDuration) / 30,
        paidAmount: Number(this.paymentAmount),
        expirationDate: this.payment.paymentExpirationDate,
        paymentMode: "paypal",
        userId: JSON.parse(localStorage["user-id"]),
        profileId: this.$route.params.id,
        orderId: details.id,

      });
      this.$router.push(`/profile`);
    },
    async submitWithPromoCode(details) {
      await this.$store.dispatch(`${PAYMENT_STORE_KEY}/promoCodeValidation`, {
        code: this.paymentPromoCode,
        planId: this.selectedPaymentPlanId,
        withPromo: "promo",
        amount: this.paymentAmount
      });
      await this.$store.dispatch(
        `${PAYMENT_STORE_KEY}/paypalPromoCodePayment`,
        {
          uniqueSlug: "AthleteProfile",
          uSlug: "AthleteProfile",
          duration: Number(this.paymentDuration),
          code: this.paymentPromoCode,
          promoName: this.promoCode.title,
          profileId: this.$route.params.id,
          lastPlanId: this.selectedPaymentPlanId,
          orderId: details.id,
          initPaymentId: this.initializePayment.paymentId
        }
      );
      await this.$store.dispatch(`${PAYMENT_STORE_KEY}/createPaymentHistory`, {
        paymentDate: new Date(Date.now()),
        termPlan: Number(this.paymentDuration) / 30,
        paidAmount: Number(this.paymentAmount),
        expirationDate: this.payment.paymentExpirationDate,
        paymentMode: "paypal",
        userId: JSON.parse(localStorage["user-id"]),
        profileId: this.$route.params.id,
        code: this.paymentPromoCode,
        orderId: details.id,
      });
      this.$router.push(`/profile`);
    },
    async dispatcher() {
      await this.$store.dispatch(`${PAYMENT_STORE_KEY}/getAthletePaymentPlans`);
    },
    validateForm() {
      return true;
    },
    onRadioChange(e) {
      this.value = e.target.value;
    },
    handlePlanChange(val) {
      this.selectedPaymentPlanId = val;
      if (val === "601d2cf5500526206c4d60ee") {
        this.isFree = true;
      } else {
        this.isFree = false;
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    // Only show error after a field is touched.
    handleError(val) {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched(val) && getFieldError(val);
    },

    // Submit value
    async handleSubmit(e) {
      e.preventDefault();
      if (!this.disableCheck) {
        this.$notification.error({
          message: "Error",
          description: "Please Agree To Terms And Select a Term Plan To Proceed"
        });
        return;
      }
      let expirationDate = new Date().getTime();
      let duration = this.paymentPlans.find(
        plan => plan._id === "601d2cf5500526206c4d60ee"
      )["duration"];
      expirationDate = new Date(
        Number(expirationDate) + Number(duration) * 86400000
      );

      await this.$store.dispatch(`${ATHLETE_STORE_KEY}/updateAthlete`, {
        id: this.$route.params.id,
        profileType: "Free",
        expiryDate: expirationDate,
        slug: "athlete"
      });
      localStorage.setItem("user-free-profile-quota", false);
      this.$router.push("/profile");
    }
  },
  watch: {
    paymentPlans(newVal) {
      this.planList =
        localStorage["user-free-profile-quota"] === "true"
          ? newVal.filter(item => item._id !== "601d2cf5500526206c4d60ee")
          : new Array(...newVal);
    },
    promoCode(newVal, _) {
      if (newVal.discountType === "amount") {
        this.paymentAmount = this.paymentAmount - Number(newVal.discount);
        this.discountedAmount = newVal.discount;
      } else {
        this.discountedAmount = parseFloat(((newVal.discount/100)* this.paymentAmount)).toFixed(2)
        let d = ((newVal.discount/100)* this.paymentAmount).toFixed(2);
        this.paymentAmount = parseFloat(this.paymentAmount - d).toFixed(2)
      }
    },
    selectedPaymentPlanId(newVal, _) {
      const selectedItem = this.paymentPlans.find(item => item._id === newVal);
      this.paymentPromoCode = "";
      this.$store.dispatch(`${PAYMENT_STORE_KEY}/clearPromoCode`).then(() => {
        if (selectedItem) {
          this.paymentAmount = Number(selectedItem.price);
          this.paymentDuration = Number(selectedItem.duration);
          this.discountedAmount = "";
        }
      });
    }
  }
};
</script>
<style lang="scss">
.payment-form-wrap {
  .add-payment-container {
    z-index: 99999;
    max-width: 600px;
    margin: 0 auto;
    padding: 40px 30px;
    background: #ffffff;
    box-shadow: 0 3px 10px 3px rgba(0, 0, 0, 0.05);
    .ant-form-item-label {
      text-align: left;
    }
    .promo-container {
      margin: 30px 0;
      padding: 30px;
      border-radius: 10px;
      border: 1px dashed grey;
      .head {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 20px;
        color: rgba(0, 0, 0, 0.75);
      }
      .promo-wrap {
        display: flex;
        flex-wrap: wrap;
        .ant-form-item {
          width: 60%;
          padding-right: 20px;
        }
        .promo-send {
          width: 40%;
          .ant-btn {
            width: 100%;
            line-height: 40px;
            height: 40px;
          }
        }
      }
    }
    .radio-wrap {
      margin-bottom: 20px;
    }
    .payment-option-list {
      .info {
        margin: 30px auto 15px;
        font-size: 14px;
        font-weight: 500;
        color: #4a4a4a;
        max-width: 450px;
      }
      .ant-checkbox {
        & + span {
          font-weight: 500;
        }
      }
    }
  }
}
</style>
